import { Maybe } from 'types/FMSGraphqlTypes'
import { formatDate } from 'utils/formatDatetime'
import { TCarrierSmartWayRegistration } from '../types'

interface IGetSmartWayCarrierResult {
  registeredLabel: 'Yes' | 'No'
  renewalDateLabel: Maybe<string>
}

export const getSmartWayCarrierLabels = (
  smartWayCarrierPreference: Maybe<TCarrierSmartWayRegistration>
): IGetSmartWayCarrierResult => {
  const { isRegistered, renewalDate } = smartWayCarrierPreference || {}

  return {
    registeredLabel: isRegistered ? 'Yes' : 'No',
    renewalDateLabel: isRegistered ? `Renews ${formatDate(renewalDate, 'monthYear')}` : null,
  }
}
